import PropTypes from 'prop-types';
import React from 'react';

import 'commons-vehicle/Vehicle/components/CallToAction/ThirdParties/Roadster/RoadsterCTA.scss';

const RoadsterCTA = ({ buttonClass, ctaLabel, serialNo, buttonLink, lang }) => {
    if (!serialNo || !buttonLink || !lang) return null;

    return (
        <a
            href={`${buttonLink}/express/${serialNo}?locale=${lang}-ca`}
            target="_blank"
            rel="noreferrer"
            onClick="event.stopPropagation()"
            className={`${buttonClass} roadster-cta`}
        >
            <span className="roadster-label">{ctaLabel}</span>
        </a>
    );
};

RoadsterCTA.defaultProps = {
    buttonClass: 'sr-button-1',
    ctaLabel: null,
    serialNo: '',
    buttonLink: '',
    lang: 'en',
};

RoadsterCTA.propTypes = {
    buttonClass: PropTypes.string,
    ctaLabel: PropTypes.string,
    serialNo: PropTypes.string,
    buttonLink: PropTypes.string,
    lang: PropTypes.string,
};

RoadsterCTA.displayName = 'RoadsterCTA';

export default RoadsterCTA;
